module.exports = __webpack_public_path__ + "img/CLS_new.65f295db.png";